import Swiper from 'swiper/bundle';

const MediaTextarea = () => {
    const sliders = document.querySelectorAll('.media-textarea__swiper');

    if (!sliders.length) return;

    sliders.forEach(slider => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.media-textarea__swiper-wrapper');

        if (!swiperWrapper) return;

        const currentSlide = slider.querySelector('.media-textarea__current');

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: false,
            navigation: {
                nextEl: slider.querySelector('.media-textarea__nav--next'),
                prevEl: slider.querySelector('.media-textarea__nav--prev'),
            },
            on: {
                init(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
                slideChange(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
            },
        });
    });
};

export default MediaTextarea;
